module.exports = __webpack_public_path__ + "static/img/building.db6802e.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/building.png
// module id = Bl3G
// module chunks = 1